module.exports = __webpack_public_path__ + "static/img/coupon.056b133f.png";